import { CustomAnalyticsReportColumnHelpSchema } from "@redotech/redo-analytics-common/reports/custom-analytics-report";
import * as z from "zod";
import { getHomeMetrics } from "./get-home-metrics";

/** The cards read through unified analytics, each the figure a custom report with that metric
 * and a "Last 30 days" filter returns. Null until the warm reaches the merchant. */
export const getHomeMetricsUnified = {
  name: "getHomeMetricsUnified" as const,
  input: z.null(),
  output: getHomeMetrics.output
    .extend({
      /** The label and help each metric's report column shows for its amount, by `type`. */
      columnHelp: z.array(
        z.object({
          type: z.string(),
          label: z.string(),
          help: CustomAnalyticsReportColumnHelpSchema,
        }),
      ),
    })
    .nullable(),
};
